import Phaser from 'phaser';
import { eventBus, EVENTS } from '../EventBus';
import { LEVELS } from '../data/levels';
import type { GameMode, LevelDefinition, LevelId, ScreenPayload } from '../types';
import { addBrand, drawDigitalCityBackdrop } from './sceneArt';

export class InstructionsScene extends Phaser.Scene {
  private level: LevelDefinition = LEVELS.quick;
  private community = 'Another Community';
  private mode: GameMode = 'quick';
  constructor() { super('InstructionsScene'); }
  init(data: { levelId?: LevelId; community?: string; mode?: GameMode }): void { this.level = LEVELS[data.levelId ?? 'quick']; this.community = data.community ?? 'Another Community'; this.mode = data.mode ?? 'packet'; }

  create(): void {
    drawDigitalCityBackdrop(this);
    this.add.rectangle(800, 410, 1240, 570, 0x031026, 0.9).setStrokeStyle(3, 0x168cff, 0.55);
    const communityMode = this.mode !== 'packet' && this.mode !== 'bonus';
    this.add.text(800, 120, 'PLAYER 1 READY', {
      fontFamily: 'Arial Black, Arial, sans-serif', fontSize: '52px', color: '#ffffff',
    }).setOrigin(0.5);
    this.add.text(800, 177, communityMode ? (this.mode === 'mayor' ? 'MAYOR CHALLENGE' : 'CONNECT 360') : 'PACKET RUNNER • INSIDE THE NETWORK', {
      fontFamily: 'Arial, sans-serif', fontSize: '19px', fontStyle: 'bold', color: '#ff8a34', letterSpacing: 4,
    }).setOrigin(0.5);

    const labels = communityMode ? ['HOME', 'SCHOOL', 'CLINIC', 'BUSINESS', 'COMMUNITY HUB'] : this.level.checkpoints.map((item) => item.shortLabel);
    const count = labels.length;
    const y = 338;
    labels.forEach((label, index) => {
      const x = count === 1 ? 800 : 235 + index * (1130 / (count - 1));
      if (index < count - 1) this.add.rectangle(x + 565 / (count - 1), y, 1060 / (count - 1), 7, 0x168cff, 0.5);
      this.add.circle(x, y, 34, index === count - 1 ? 0xff8a34 : 0x0b2752, 1)
        .setStrokeStyle(5, index === count - 1 ? 0xffb37a : 0x1ed8ff, 1);
      this.add.text(x, y, `${index + 1}`, { fontFamily: 'Arial Black, Arial, sans-serif', fontSize: '22px', color: '#ffffff' }).setOrigin(0.5);
      this.add.text(x, y + 54, label, { fontFamily: 'Arial, sans-serif', fontSize: '13px', fontStyle: 'bold', color: '#ffffff' }).setOrigin(0.5);
    });
    this.add.text(800, 475, communityMode ? `MISSION: LIGHT UP ${this.community.toUpperCase()}` : 'DEVICE → ROUTER → SWITCH → INTERNET → FIREWALL → SERVER', {
      fontFamily: 'Arial, sans-serif', fontSize: '25px', fontStyle: 'bold', color: '#ffffff', align: 'center', wordWrap: { width: 1100 },
    }).setOrigin(0.5);
    this.add.text(800, 548, 'MOVE', { fontFamily: 'Arial Black, Arial, sans-serif', fontSize: '15px', color: '#8fdfff', letterSpacing: 3 }).setOrigin(0.5);
    this.add.text(800, 592, 'LEFT STICK / D-PAD   •   TOUCH ARROWS   •   ARROWS / WASD', { fontFamily: 'Arial Black, Arial, sans-serif', fontSize: '21px', color: '#1ed8ff' }).setOrigin(0.5);
    this.add.text(800, 650, communityMode ? 'Collect signals • Connect each location in order • Use power-ups' : 'Collect data • Follow the route • Avoid network disruptions', { fontFamily: 'Arial, sans-serif', fontSize: '18px', color: '#ffffff' }).setOrigin(0.5);
    addBrand(this, 830);
    eventBus.emit<ScreenPayload>(EVENTS.screen, { name: 'instructions', level: this.level, community: this.community, mode: this.mode });
  }
}
